<template>
<div>
   <!-- BOC:[header] -->
   <v-row class="mb-3">
      <v-col class="text-right">
        <v-btn
          color="primary"
          large
          class="mr-2"
          :to="{
            name: 'PageModeratorBookChapterChapterQuestionChapterQuestionOptionAdd',
            params: {
              parentId: parent.id,
              parent: parent,
              grandParentId: grandParent.id,
              grandParent: grandParent,
              greatGrandParentId : greatGrandParent.id,
              greatGrandParent: greatGrandParent,
            },
          }"
        >
         + New Option
        </v-btn>
      </v-col>
    </v-row>
    <!-- EOC -->
  <!-- BOC:[table] -->
  <BreadBrowseTable
    role="Moderator"
    :model="model"
    :url="`${$api.servers.game}/api/v1/en/moderator/book/${$route.params.parentId}/chapter/${$route.params.grandParentId}/question/${parent.id}/option`"
    :isSearchable="true"
    :parent="parent"
    :modelParent="modelParent"
    :grandParent="grandParent"
    :modelGrandParent="modelGrandParent"
    :greatGrandParent="greatGrandParent"
    :modelGreatGrandParent="modelGreatGrandParent"
  ></BreadBrowseTable>
  <!-- EOC -->
</div>
</template>

<script>
  //BOC:[model]
  import modelGreatGrandParent from '@/models/items/book'
  import modelGrandParent from '@/models/items/chapter'
  import modelParent from '@/models/items/chapterQuestion'
  import model from '@/models/items/chapterQuestionOption'
  //EOC
  //BOC:[table]
  import BreadBrowseTable from '@/components/Bread/BreadBrowseTable'
  //EOC
  import { mapState } from 'vuex'
  export default {
    components:{
      //BOC:[table]
      BreadBrowseTable,
      //EOC
    },
    computed: mapState({
      school: state => state.school.data,
    }),
    props:[
      'role',
      'parent',
      'grandParent',
      'greatGrandParent'
    ],
    data:()=>({
      //BOC:[model]
      modelParent:modelParent,
      modelGrandParent: modelGrandParent,
      modelGreatGrandParent: modelGreatGrandParent,
      model: model,
      //EOC
    }),
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>